// Календарь (кнопка date_picker шапки): месяц сеткой с понедельника, листается ‹ › без ограничений (дата +365 дней —
// запрос уходит, пустой день — серверный empty_state). Точки — дни с матчами из screens/match-day/counts/ показанного
// месяца по топ-лигам сервера (config.match_center_sync.top_league_ids; красная — есть живые). Закрывается крестиком,
// тапом по фону и системной «Назад» Telegram.
import { useEffect, useMemo, useState } from 'react';
import { timezoneOffset, useMatchDayCounts } from '../../api/matchDay';
import { formatDate, t } from '../../i18n/i18n';
import closeIcon from '../../assets/icons/x.svg';
import { MaskIcon } from '../../ui/Icon';
import { useOverlayBack } from '../../ui/useOverlayBack';
import { monthEnd, monthGrid, shiftMonth } from './days';
import styles from './MatchCenter.module.css';

export function CalendarSheet({ today, selected, leagues, onPick, onClose }: {
  today: string; selected: string; leagues: number[]; onPick: (day: string) => void; onClose: () => void;
}) {
  const [month, setMonth] = useState(selected.slice(0, 7));
  useOverlayBack(onClose);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  const counts = useMatchDayCounts(`${month}-01`, monthEnd(month), timezoneOffset(), leagues, true);
  const byDate = useMemo(() => new Map((counts.data?.days ?? []).map((d) => [d.date, d])), [counts.data]);
  const weekdays = useMemo(() => Array.from({ length: 7 }, (_, i) =>
    formatDate(new Date(Date.UTC(2024, 0, 1 + i)), { weekday: 'narrow', timeZone: 'UTC' })), []);
  const first = new Date(`${month}-01T00:00:00Z`);
  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.sheet} role="dialog" aria-modal="true" aria-label={t('matchCenter.calendar')} onClick={(e) => e.stopPropagation()}>
        <div className={styles.sheetHead}>
          <button className={styles.navBtn} aria-label={t('matchCenter.prevMonth')} onClick={() => setMonth(shiftMonth(month, -1))}>‹</button>
          <h3 className={styles.monthTitle}>{formatDate(first, { month: 'long', year: 'numeric', timeZone: 'UTC' })}</h3>
          <button className={styles.navBtn} aria-label={t('matchCenter.nextMonth')} onClick={() => setMonth(shiftMonth(month, 1))}>›</button>
          <button className={styles.closeBtn} aria-label={t('matchCenter.close')} onClick={onClose}><MaskIcon src={closeIcon} size={20} /></button>
        </div>
        <div className={styles.grid}>
          {weekdays.map((w, i) => <span key={`w${i}`} className={styles.weekday}>{w}</span>)}
          {monthGrid(month).map((date, i) => {
            if (!date) return <span key={`o${i}`} />;
            const c = byDate.get(date);
            return (
              <button key={date} data-date={date} aria-pressed={date === selected} onClick={() => onPick(date)}
                className={`${styles.cell} ${date === selected ? styles.cellActive : ''} ${date === today ? styles.cellToday : ''}`}>
                {Number(date.slice(8))}
                {c && c.match_count > 0 && <span className={`${styles.dot} ${(c.live_count ?? 0) > 0 ? styles.dotLive : ''}`} aria-hidden="true" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
